// import './cart';
// import './breakpoint';
// import './popup-links';

const updateStore = (newStore) => {
  //check if store changed
  if (JSON.stringify(window.__VPV.store) !== JSON.stringify({ ...window.__VPV.store, ...newStore })) {
    const oldStore = { ...window.__VPV.store };
    window.__VPV.store = { ...window.__VPV.store, ...newStore };
    let vpvStoreEvent = new CustomEvent('vpvUpdate', {
      detail: { oldStore, newStore: window.__VPV.store }
    });

    window.dispatchEvent(vpvStoreEvent);
  }
}

const subscribe = (callbackFn) => {
  const handler = (event) => callbackFn(window.__VPV.store, event.detail.oldStore);
  window.addEventListener('vpvUpdate', handler);
  return () => window.removeEventListener('vpvUpdate', handler);
};

const watch = (selector, callbackFn) => {
  return subscribe((store, oldStore) => {
    const newVal = selector(store);
    const oldVal = selector(oldStore);
    if (newVal !== oldVal) callbackFn(newVal, oldVal, store);
  });
};

window.__VPV = {
  ...window.__VPV,
  store: { productVehiclePickerOpen: true, ...window.__VPV?.store },
  updateStore,
  subscribe,
  watch
}
